import { createContext } from 'react';

/** Shared property preview visibility state for communications descendants. */
export const PropertyPreviewVisibilityContext = createContext(true);
